// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import IdMappingSvg from '@rsuite/icon-font/lib/people/IdMapping';
var IdMapping = createSvgIcon({
  as: IdMappingSvg,
  ariaLabel: 'id mapping',
  category: 'people',
  displayName: 'IdMapping'
});
export default IdMapping;